module.exports = __webpack_public_path__ + "img/inactive-clone.58d34d7f.svg";